import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { API_URL } from '../../../models/environment.token'
import { firstValueFrom } from 'rxjs'
import { MapBoxToken } from '../interfaces/map-box-token.interface'

@Injectable({ providedIn: 'root' })
export class MapTokenService {
  private token?: MapBoxToken
  private readonly http = inject(HttpClient)
  private readonly apiUrl = inject(API_URL)

  private tokenExpiresSoon(): boolean {
    if (!this.token) return true
    const expires = new Date(this.token.expires).getTime()
    // Mapbox caps temporary tokens at 1h and the backend mints them for 58min, so the
    // freshness margin must stay well below that lifetime otherwise the token is always
    // considered expired and refetched on every map operation. Refresh only when it has
    // less than 5min left.
    const safeAhead = Date.now() + 5 * 60 * 1000
    return expires < safeAhead
  }

  async ensureToken(): Promise<string> {
    if (!this.token || this.tokenExpiresSoon()) {
      const result = await firstValueFrom(this.http.get<MapBoxToken>(`${this.apiUrl}/geolocation/token`))
      this.token = result
    }
    return this.token.token
  }

  get cachedToken(): string | undefined {
    return this.token?.token
  }
}
